import { findIndex } from 'lodash';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export type RecipeGroup = {
  type: string;
  data: any;
};

type RecipeGroupType = 'tx_code' | 'tx_builder';

type GetRecipeGroupByType = (type: RecipeGroupType) =>
  | {
      group: RecipeGroup;
      index: number;
    }
  | undefined;

export type UseRecipeBuilderRepository = {
  recipeGroups: RecipeGroup[];
  expandedRecipeGroupIndex: number;
  expandedRecipeIndex: number;
  isRecipeUnapplied: boolean;
  autoApply: boolean;
  isAsync: boolean;
  parsingErrors: any;
  selectedAttrs: any;
  appliedSchemaSpecId: string | null;
  destinationDraft: any | null;
  nexsetSampleDraft: any | null;
  isLegacyMode: boolean;
  getRecipeGroupByType: GetRecipeGroupByType;
  getRecipesGroupByType: (type: RecipeGroupType) => RecipeGroup[];
};

export default function useRecipeBuilderRepository(): UseRecipeBuilderRepository {
  const recipeBuilder = useSelector((state: any) => state.recipeBuilder);

  const getRecipeGroupByType = useCallback(
    (type: string) => {
      const recipeGroups: RecipeGroup[] = recipeBuilder.recipeGroups;
      const index = findIndex(recipeGroups, (group) => group.type === type);
      const group = recipeGroups[index];
      return group ? { group, index } : {};
    },
    [recipeBuilder.recipeGroups],
  );

  const getRecipesGroupByType = useCallback(
    (type: string) => {
      const recipeGroups: RecipeGroup[] = recipeBuilder?.recipeGroups ?? [];
      return recipeGroups.filter((g) => g?.type === type);
    },
    [recipeBuilder.recipeGroups],
  );

  return {
    ...recipeBuilder,
    getRecipeGroupByType,
    getRecipesGroupByType,
  };
}
